import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Store,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.actor}stores`;

export interface GetStoresQueryArgs {
  sellerId?: string;
  tenantId?: string;
}

async function getStoresQuery({
  sellerId,
  tenantId,
}: GetStoresQueryArgs = {}): Promise<
  BackResponse<Store[]> | BackResponseFailure
> {
  try {
    const url = buildUrl(ENDPOINT, { sellerId, tenantId });

    const response = await apiCall<BackResponse<Store[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default getStoresQuery;
